import { corpusCountPlus } from './corpus';
import React from 'react';

// `num: null` → la carte lit le compte RÉEL du corpus au rendu. Elle
// annonçait « 2.5 M », soit 600 fois la taille réelle de `legal_db_v2`
// (cf. `./corpus`). Les trois autres chiffres ne sont pas des comptes de
// documents et restent tels quels.
const CARDS = [
  { key: 'docs',     num: null,  unit: '' },
  { key: 'statutes', num: '900', unit: 'K' },
  { key: 'codes',    num: '27',  unit: '' },
  { key: 'refresh',  num: '24',  unit: 'h' },
];

export default function KnowledgeBase({ t, language }) {
  return (
    <section className="section" data-testid="engine-knowledge">
      <div className="section-inner">
        <div className="section-head">
          <div className="section-eyebrow">{t('knowledge_base.eyebrow')}</div>
          <h2 className="section-h">{t('knowledge_base.title', { count: corpusCountPlus(language) })}</h2>
          <p className="section-sub">{t('knowledge_base.subtitle')}</p>
        </div>

        <div className="kb-grid">
          {CARDS.map((c) => (
            <div className="kb-card" key={c.key}>
              <div className="kb-num">
                {c.num ?? corpusCountPlus(language)}
                {c.unit && <span className="kb-unit">{c.unit}</span>}
              </div>
              <div className="kb-label">{t(`knowledge_base.cards.${c.key}.label`)}</div>
              <div className="kb-desc">{t(`knowledge_base.cards.${c.key}.desc`)}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
